// Constants for field groups in OTMM.

export const NOMINATIONS_FG = 'DISMD.CATEGORY.CRWS.NOMINATIONS';
export const REVIEW_PROCESS_FG = 'CRWS.TABLE.REVIEW_PROCESS_UI';
